import React from "react";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { Flex } from "theme-ui";
import PropTypes from "prop-types";
import { colors, typography } from "../../styles/theme";
import { openBeaconBarChat } from "./beaconBar";

const AskNavosButton = ({ label = "Ask NAVOS", onClick, compact = false }) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }

    openBeaconBarChat();
  };

  return (
    <AskNavosButtonOuter
      type="button"
      onClick={handleClick}
      compact={compact}
      aria-label={compact ? label : undefined}
    >
      <AskNavosButtonInner compact={compact}>
        <AskNavosIcon src={ASK_NAVOS_ICON_GIF} alt="" aria-hidden="true" compact={compact} />
        {!compact && label}
      </AskNavosButtonInner>
    </AskNavosButtonOuter>
  );
};

AskNavosButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  compact: PropTypes.bool,
};

export default AskNavosButton;

const ASK_NAVOS_ICON_GIF =
  "https://www.datocms-assets.com/40521/1781508776-ai-generating-1.gif";

const movingGradient = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const AskNavosIcon = styled.img`
  width: ${({ compact }) => (compact ? "1.25rem" : "1.5rem")};
  height: ${({ compact }) => (compact ? "1.25rem" : "1.5rem")};
  object-fit: contain;
  flex-shrink: 0;
`;

const AskNavosButtonOuter = styled.button`
  display: inline-flex;
  padding: 4px;
  border: none;
  border-radius: 9999px;
  width: ${({ compact }) => (compact ? "3.75rem" : "auto")};
  background: linear-gradient(
    -45deg,
    ${colors.secondaryOrangeMain},
    #aa00ea,
    ${colors.secondaryOrangeMain},
    #aa00ea,
    ${colors.secondaryOrangeMain}
  );
  background-size: 400% 400%;
  animation: ${movingGradient} 4s ease infinite;
  cursor: pointer;
  flex-shrink: 0;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 16px rgba(170, 0, 234, 0.25);
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    background: linear-gradient(
      90deg,
      ${colors.secondaryOrangeMain} 0%,
      #aa00ea 45%,
      ${colors.secondaryOrangeMain} 100%
    );
    background-size: auto;
  }
`;

const AskNavosButtonInner = styled(Flex)`
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: ${({ compact }) => (compact ? "100%" : "auto")};
  min-height: ${({ compact }) => (compact ? "calc(2.75rem - 4px)" : "calc(3rem - 4px)")};
  padding: ${({ compact }) => (compact ? "0" : "0.875rem 2rem")};
  border-radius: 9999px;
  background: linear-gradient(180deg, #3d1a5c 0%, #1f0a33 100%);
  color: ${colors.white};
  font-family: ${typography.textMd500.fontFamily};
  font-size: ${typography.textMd500.fontSize};
  font-weight: ${typography.textMd500.fontWeight};
  line-height: ${typography.textMd500.lineHeight};
  white-space: nowrap;

  @media (max-width: 599px) {
    padding: ${({ compact }) => (compact ? "0" : "0.875rem 1rem")};
  }
`;
